'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');
var polished = require('polished');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2;
var ActionButton$1 = styled__default['default'].button.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  border: 0;\n  color: inherit;\n  background-color: transparent;\n  ", "\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 0 0;\n  transition: background-size 250ms ease;\n  cursor: pointer;\n\n  ", "\n\n  ", "\n\n  &:disabled {\n    opacity: 0.5;\n    color: inherit;\n    cursor: not-allowed;\n  }\n\n  svg {\n    width: 100%;\n    max-height: 20px;\n    max-width: 20px;\n    pointer-events: none;\n    transition: color 250ms;\n  }\n"])), function (props) {
  return "".concat(props.buttonWidthHeight[0], "px");
}, function (props) {
  return "".concat(props.buttonWidthHeight[1], "px");
}, function (props) {
  var _props$backgroundColo, _props$backgroundColo2, _props$backgroundColo3, _props$backgroundColo4;

  var darkThemeBgColor = (_props$backgroundColo = props === null || props === void 0 ? void 0 : (_props$backgroundColo2 = props.backgroundColors) === null || _props$backgroundColo2 === void 0 ? void 0 : _props$backgroundColo2[0]) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : props.theme.getColor('gray-600');
  var lightThemeBgColor = (_props$backgroundColo3 = props === null || props === void 0 ? void 0 : (_props$backgroundColo4 = props.backgroundColors) === null || _props$backgroundColo4 === void 0 ? void 0 : _props$backgroundColo4[1]) !== null && _props$backgroundColo3 !== void 0 ? _props$backgroundColo3 : props.theme.getColor('gray-200');
  return props.theme.themeProp('background-image', "radial-gradient(circle at center, ".concat(darkThemeBgColor, " 50%, transparent 50%)"), "radial-gradient(circle at center, ".concat(lightThemeBgColor, " 50%, transparent 50%)"));
}, function (props) {
  return styled.css(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n    ", ":not(:disabled) {\n      background-size: 200% 200%;\n\n      svg {\n        ", ";\n      }\n    }\n  "])), props.active ? '' : ':hover', function (props) {
    return props.theme.themeProp('color', props.theme.getColor('gray-100'), props.theme.getColor('gray-700'));
  });
}, function (props) {
  return props.useShadow ? props.theme.themeProp('box-shadow', "0px 3px 6px ".concat(polished.rgba(props.theme.getColor('black'), 0.7)), "0px 3px 6px ".concat(props.theme.getColor('black'))) : null;
});

var ActionButton = React__default['default'].forwardRef(function ActionButton(_ref, forwardedRef) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      active = _ref.active,
      onClick = _ref.onClick,
      buttonWidthHeight = _ref.buttonWidthHeight,
      props = defaultTheme._objectWithoutProperties(_ref, ["icon", "disabled", "active", "onClick", "buttonWidthHeight"]);

  return React__default['default'].createElement(ActionButton$1, defaultTheme._extends({
    ref: forwardedRef,
    disabled: disabled,
    active: active,
    onClick: onClick,
    buttonWidthHeight: buttonWidthHeight
  }, props), icon);
});
ActionButton.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: defaultTheme.PropTypes.element.isRequired,
  disabled: defaultTheme.PropTypes.bool,
  active: defaultTheme.PropTypes.bool,
  onClick: defaultTheme.PropTypes.func,
  backgroundColors: defaultTheme.PropTypes.arrayOf(defaultTheme.PropTypes.string),
  buttonWidthHeight: defaultTheme.PropTypes.array
} : {};
ActionButton.defaultProps = {
  onClick: function onClick() {},
  buttonWidthHeight: [40, 40]
};

exports.ActionButton = ActionButton;
